import { Component } from '@angular/core';

@Component({
  selector: 'ngx-one-column-main-layout',
  styleUrls: ['./one-column-main.layout.scss'],
  template: `
    <nb-layout windowMode>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
      
    </nb-layout>
  `,
})
export class OneColumnMainLayoutComponent {}
